export var AssignmentDateParms;
(function (AssignmentDateParms) {
    AssignmentDateParms[AssignmentDateParms["Create"] = 0] = "Create";
    AssignmentDateParms[AssignmentDateParms["Start"] = 1] = "Start";
    AssignmentDateParms[AssignmentDateParms["Warn"] = 2] = "Warn";
    AssignmentDateParms[AssignmentDateParms["Late"] = 3] = "Late";
    AssignmentDateParms[AssignmentDateParms["Escalate"] = 4] = "Escalate";
})(AssignmentDateParms || (AssignmentDateParms = {}));
;
